import AlreadyRegisteredDialog from 'register/dialogs/AlreadyRegisteredDialog';

export const ALREADY_REGISTERED_DIALOG = 'ALREADY_REGISTERED_DIALOG';

const dialogs = {
  [ALREADY_REGISTERED_DIALOG]: AlreadyRegisteredDialog,
};

export default dialogs;
